/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExecutePendingActionsDto } from '../models/ExecutePendingActionsDto';
import type { PendingAction } from '../models/PendingAction';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PendingActionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a new pending action.
     * @param requestBody
     * @returns PendingAction OK
     * @throws ApiError
     */
    public createPendingAction(
        requestBody?: PendingAction,
    ): CancelablePromise<PendingAction> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/PendingAction/CreatePendingAction',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Execute a pending action based on the given item GUID and trigger date.
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public executePendingAction(
        requestBody?: ExecutePendingActionsDto,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/PendingAction/ExecutePendingAction',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
